import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AmplitudeService } from 'src/app/core/services/amplitude.service';
import { LocaleService } from '@shared/services/locale.service';
import { ViewportService } from '@shared/services/viewport.service';

@Component({
	selector: 'app-ads-banner',
	templateUrl: './ads-banner.component.html',
	styleUrls: ['./ads-banner.component.scss'],
})
export class AdsBannerComponent implements OnInit {
	constructor(public locale: LocaleService, public viewport: ViewportService, private amplitude: AmplitudeService, private router: Router) {}

	@Input() isHotPage: boolean = false;

	onClickAds(): void {
		this.amplitude.trackAds();
		
		if (this.viewport.type !== 'desktop') {
			if (/Android/i.test(navigator.userAgent)) {
				const appPackage = 'com.opaxlabs.kurdshopping';
				const playStoreURL = `market://details?id=${appPackage}`;
				window['location']['href'] = playStoreURL;
			} else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
				const appID = '537659933'; // Replace with your app's unique identifier
				const appStoreUrl = `itms-apps://itunes.apple.com/app/${appID}`;
				window.location.href = appStoreUrl;
			} else if (/HarmonyOS/i.test(navigator.userAgent)) {
				window['location']['href'] = 'https://appgallery.huawei.com/#/app/C100966239';
			}
		}
	}

	onGotoTelegram() {
		window.location.href = 'https://t.me/ksbuysell';
	}

	ngOnInit(): void {}
}
